// extracted by mini-css-extract-plugin
export default {"textInput":"date-input-local__textInput___ZmeA3Uuq","textInputWrapper":"date-input-local__textInputWrapper___aJkUiCmZ","wrapper":"date-input-local__wrapper___0g8eirOG"};